/** @jsxImportSource @emotion/react */
import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { IStation, IStationConnector } from '../../api/station/types';

import { SetConnector } from './components/set-connector/set-connector.component';
import setUpStyles from './set-up.styles';
import SpinnerLoader from '../../components/spinner-loader/spinner-loader.component';
import { setSetupModal } from '../../store/setup-modal/setup-modal.slice';
import { useLeafletMap } from '../../components/leaflet-map/MapContext';
import { LatLngExpression } from 'leaflet';
import { ILocationResponse } from '../../api/locations/types';
import { buildStationConnectorPath } from '../../utils/station';

type PropTypes = {
    location?: ILocationResponse;
    locationLoading: boolean;
};

export const SetUp: FC<PropTypes> = ({ location, locationLoading }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { map, zoomToLocation } = useLeafletMap();

    useEffect(() => {
        if (map && location) {
            zoomToLocation(location?.data?.location?.coordinates?.toReversed() as LatLngExpression);
        }
    }, [location, map, zoomToLocation]);

    const handlePressConnector = (connector: IStationConnector & { station: IStation }) => {
        navigate(buildStationConnectorPath(connector.station._id, connector._id));
        dispatch(setSetupModal({ connector }));
    };

    if (locationLoading) {
        return (
            <div css={setUpStyles.loaderContainer}>
                <SpinnerLoader />
            </div>
        );
    }

    return <SetConnector location={location?.data} onPress={handlePressConnector} />;
};
